export function SubscriptionTypeUpgradeCtrl (
  $scope, 
  $window, 
  sessionObjAPI, 
  workshopAPI, 
  messages
) {
  $scope.session = sessionObjAPI.base();

  if (($scope.session.silver_or_higher == true) && ($scope.session.gold_or_higher == false) && ($scope.session.platinum_or_higher == false)) {
    if ($scope.session.monthly_subscription) {
      $scope.prices = {
        gold : 30,
        platinum :  90
      }
    } else {
      $scope.prices = {
        gold : 20,
        platinum : 70
      }
    }
  } 
  else if (($scope.session.silver_or_higher == true) && ($scope.session.gold_or_higher == true) && ($scope.session.platinum_or_higher == false)) {
    if ($scope.session.monthly_subscription) {
      $scope.prices = {
        platinum :  60
      }
    } else {
      $scope.prices = {
        platinum : 50
      }
    }

  }
  else if (($scope.session.silver_or_higher == true) && ($scope.session.gold_or_higher == true) && ($scope.session.platinum_or_higher == true)) {
    if ($scope.session.monthly_subscription) {
      $scope.prices = {}
    } else {
      $scope.prices = {}
    }
  }
  else {
    if ($scope.session.monthly_subscription) {
      $scope.prices = {
        silver: 30,
        gold : 60,
        platinum :  120
      }
    } else {
      $scope.prices = {
        silver: 30,
        gold : 50,
        platinum : 100
      }
    }
  };

  $scope.confirm = function (new_sub_type) {
    return workshopAPI.get('/company/upgrade_workshop_subscription', new_sub_type)
      .then(function (data) {
        $window.location.href = '#/dashboard';
      }, function (err) {
        messages.error(err);
      });
  }

  $scope.cancel = function() {
    $window.location.href = '#/dashboard';
  } 
};